<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("prepare-date.title") }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="close"
                ></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{
                        $t("prepare-date.question-title")
                    }}</label>
                    <div class="control">
                        <input
                            class="input"
                            :class="{ 'is-danger': missingTitle }"
                            type="text"
                            v-model="title"
                        />
                        <p v-if="missingTitle" class="help is-danger">
                            {{ $t("prepare-date.is-required-question-title") }}
                        </p>
                    </div>
                </div>
                <UsersSelect v-model="selectedUsers" />
                <div class="field">
                    <label class="checkbox">
                        <input type="checkbox" v-model="limitDates" />
                        {{ $t("prepare-date.limit-date") }}
                    </label>
                </div>
                <div v-if="limitDates" class="field">
                    <label class="label">
                        {{ $t("prepare-date.min-date") }}
                    </label>
                    <div class="control">
                        <DatePicker v-model="minDate" />
                    </div>
                </div>
                <div v-if="limitDates" class="field">
                    <label class="label">
                        {{ $t("prepare-date.max-date") }}
                    </label>
                    <div class="control">
                        <DatePicker v-model="maxDate" />
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="send">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span>{{ $t("prepare-date.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import UsersSelect from "../UsersSelect.vue";
import DatePicker from "@/components/external-components/datepicker/DatePicker";

export default {
    name: "prepare-date",
    components: {
        UsersSelect,
        DatePicker,
    },
    data() {
        return {
            title: "",
            missingTitle: false,
            selectedUsers: [],

            minDate: null,
            maxDate: null,

            limitDates: false,
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        send() {
            this.missingTitle = this.title === "";
            if (this.missingTitle) {
                return;
            }

            for (let i = 0; i < this.selectedUsers.length; i++) {
                const selectedUser = this.selectedUsers[i];
                this.$emit("sendAction", {
                    type: "date",
                    title: this.title,
                    state: 0,
                    user: selectedUser,
                    minDate: this.limitDates ? this.minDate : null,
                    maxDate: this.limitDates ? this.maxDate : null,
                });
            }
        },
    },
};
</script>